import { ruRU } from "@mui/material/locale";
import { createTheme } from "@mui/material/styles";

import { breakpoints } from "./breakpoints";
import { components } from "./components";
import { palette } from "./palette";
import { typography } from "./typography";

export const MuiTheme = createTheme(
  {
    breakpoints,
    palette,
    typography,
    components,
  },
  ruRU
);
